import { ButtonIcon } from 'ui/components/primitives';
import { theme, styled, utils } from 'ui/theme';

const Payment = {
  Button: styled(ButtonIcon)`
    background: ${theme.colors.action.navigation.standard.static};
    color: ${theme.colors.build.lightLight};
    grid-gap: ${theme.space[3]};
    margin-top: ${theme.space[4]};
    ${utils.media.max('s')`
      position: fixed;
      bottom: 0;
      left: 0;
      border-radius: 0;
    `}
  `,
};

export default Payment;
